import { Spacer, theme } from '@capitalise/ui-design-system';
import styled from 'styled-components';
export default styled(Spacer)`
  margin-right: ${(props) =>
    props.noRight ? 'initial !important' : `${theme.space[props.gap]} !important`};
  margin-top: ${(props) =>
    props.noTop ? 'initial !important' : `${theme.space[props.gap]} !important`};
  > * {
    margin-right: ${(props) =>
      props.noRight ? 'initial !important' : `${theme.space[props.gap]} !important`};
    margin-top: ${(props) =>
      props.noTop ? 'initial !important' : `${theme.space[props.gap]} !important`};
  }
`;
